module.exports = __webpack_public_path__ + "img/big-logo.02a7ce03.png";